// import { useMutation } from '@apollo/client';

// import { CHANGE_CATEGORY_STATUS } from '../graphql';
// import { ChangeCategoryStatus, ChangeCategoryStatusVariables } from '../graphql-types/ChangeCategoryStatus';


// export const useChangeCategoryStatus = () => {
//   const [mutate, state] = useMutation<
//     ChangeCategoryStatus,
//     ChangeCategoryStatusVariables
//   >(CHANGE_CATEGORY_STATUS, {
//     refetchQueries: ['GetCategories'],
//   });

//   const changeCategoryStatus = async (_id: string) => {
//     const { data } = await mutate({
//       variables: {
//         input: { _id },
//       },
//     });

//     if (!data?.changeCategoryStatus.success) {
//       throw new Error(
//         data?.changeCategoryStatus.message || 'Status update failed'
//       );
//     }
//     return data.changeCategoryStatus;
//   };

//   return {
//     changeCategoryStatus,
//     ...state,
//   };
// };

import { useMutation } from '@apollo/client';

import { CHANGE_CATEGORY_STATUS } from '../graphql';
import {
  ChangeCategoryStatus,
  ChangeCategoryStatusVariables,
} from '../graphql-types/ChangeCategoryStatus';

export const useChangeCategoryStatus = () => {
  const [mutate, state] = useMutation<
    ChangeCategoryStatus,
    ChangeCategoryStatusVariables
  >(CHANGE_CATEGORY_STATUS); // ✅ removed refetchQueries

  const changeCategoryStatus = (
    _id: string,
    options?: Parameters<typeof mutate>[0], // ✅ allow cache options
  ) => {
    return mutate({
      variables: {
        input: { _id },
      },
      ...options,
    });
  };

  return {
    changeCategoryStatus,
    ...state,
  };
};
